<template>
  <div class="card">
    <h2>View latest recipients</h2>
    <p>Up to {{ limit }} of your organization's most recent recipients have been displayed below. To view the full list
      click on the <em>view full list</em> link below.
    </p>
    <div>
      <spinner :show="isLoading" />
      <family-table
        :show="!isLoading"
        :limit="limit"
        :allow-pagination="false"
        :sort-list-by="`createdDate`"
        :is-sort-desc="true"
      />
    </div>
    <div v-if="recipientCount" class="col-12">
      <router-link :to="familyListURL" class="float-right link-list">
        View Full List
      </router-link>
    </div>
  </div>
</template>

<script>
import FamilyTable from '../FamilyTable';
import routeNames from '../../util/routeNames';
import Spinner from '../Spinner';

export default {
  name: 'ListFamilies',
  components: { FamilyTable, Spinner },
  data() {
    return {
      familyListURL: routeNames.FAMILYLIST.PATH,
      limit: 5,
    };
  },
  computed: {
    isLoading: function() {
      return this.$store.getters.getIsRecipientLoading;
    },
    recipientCount: function() {
      return this.$store.getters.getRecipients.length;
    }
  },
}
</script>
